import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AvatarPurpleSvg from './icon-avatar-purple.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <AvatarPurpleSvg {...validProps} />;
}
SvgComponent.iconName = 'avatarPurple';

export const AvatarPurpleIcon = svgIconWrapper(SvgComponent);
